import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

class Uber extends Component {
  render() {
    const { location } = this.props;
    const res = location.search.slice(1);
    return (
      <Redirect
        to={{
          pathname: '/profile',
          message: 'Successfully connected to Uber',
          state: { res, formStep: 1, fromUber: true },
        }}
      />
    );
  }
}

export default Uber;



// WEBPACK FOOTER //
// ./src/components/User/Uber.js